import { h as t } from "vue";
import { s as r } from "./svgIconFactory-Dn0WJdb3.js";
const s = (e, { attrs: o }) => r({
  props: e,
  svgNodeAttrs: {
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18.471 20.196",
    height: e.height ?? 18,
    width: e.width ?? 20
  },
  childrenNodes: t(
    "g",
    { transform: "translate(0.151 0.155)" },
    t("g", [
      t("path", {
        d: "M10.19.633l0,0a.927.927,0,0,0-.492.94c.312,3.223-1.971,5.887-7.3,7.881A2.9,2.9,0,0,0,.5,12.061a2.775,2.775,0,0,0,.946,2.088,2.593,2.593,0,0,0,2.76.8c4.951-2.707,8.99-3.391,11.607-.92a.931.931,0,0,0,1.05.189,1.3,1.3,0,0,0,.591-1.732L11.922,1.224A1.294,1.294,0,0,0,10.19.633Z",
        fill: "none",
        stroke: o["stroke-color"] ?? "#222",
        "stroke-linecap": "round",
        "stroke-miterlimit": "10",
        "stroke-width": o["stroke-width"] ?? "1.3"
      }),
      t("path", {
        d: "M4.207,14.948,6.9,18.9a1,1,0,0,0,1.739-.984L6.71,13.723,4.283,8.652",
        fill: "none",
        stroke: o["stroke-color"] ?? "#222",
        "stroke-linecap": "round",
        "stroke-miterlimit": "10",
        "stroke-width": o["stroke-width"] ?? "1.3"
      }),
      t("path", {
        d: "M13.406,6.385a6.156,6.156,0,0,1,1.508-.647A1.245,1.245,0,0,1,16.16,6.983c0,.516-.3,1.1-1.539,1.621",
        transform: "translate(1 -0.371)",
        fill: "none",
        stroke: o["stroke-color"] ?? "#222",
        "stroke-linecap": "round",
        "stroke-miterlimit": "10",
        "stroke-width": o["stroke-width"] ?? "1.3"
      }),
      t("path", {
        d: "M6.674,15.711c.936-.37,2.311-1.181,1.738-2.931",
        transform: "translate(1)",
        fill: "none",
        stroke: o["stroke-color"] ?? "#222",
        "stroke-linecap": "round",
        "stroke-miterlimit": "10",
        "stroke-width": o["stroke-width"] ?? "1.3"
      })
    ])
  )
});
export {
  s as MegaphoneIcon
};
